export const isInternalLink = (link: string) => {
  return /^\/(?!\/)/.test(link) || !/^https?:\/\//i.test(link)
}
